import { render } from "./secret.vue?vue&type=template&id=128795a2"
import script from "./secret.vue?vue&type=script&lang=js"
export * from "./secret.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__